import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";

import setAuthToken from "./utils/setAuthToken";
import NotFound from "./views/errors/404";
import Routes from "./routing/Routes";
import Tokenize from "./views/tokenize";
import RegistrationHandoff from "./views/registration-handoff";
import {PublicWrapper as Public} from "./views/public/wrapper";

import { LOGOUT } from "./actions/types";
import { loadUser } from "./actions/auth";
import { authDebug } from "./utils/api";

import store from "./store";

const App = () => {
  useEffect(() => {
    const isTokenizeCallback = ["/authentic/tokenize", "/authentic/register"].includes(window.location.pathname);

    if (!isTokenizeCallback) {
      // check for token in LS
      if (localStorage.token) {
        authDebug("app:start-with-token", {
          api: localStorage.api || null
        });
        setAuthToken(localStorage.token);
        store.dispatch(loadUser());
      } else {
        authDebug("app:start-without-token");
        store.dispatch({ type: LOGOUT });
      }
    }

    // log user out from all tabs if they log out in one tab
    window.addEventListener("storage", () => {
      if (!localStorage.token) {
        authDebug("app:storage-token-missing");
        store.dispatch({ type: LOGOUT });
      }
    });
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route exact path="/authentic/tokenize" component={Tokenize} />
          <Route exact path="/authentic/register" component={RegistrationHandoff} />
          <Route exact path="/public/license/:category" component={Public} />
          <Route component={Routes} />
          <Route path="*" component={NotFound} />
        </Switch>
      </Router>
    </Provider>
  );
};

export default App;
